/* eslint-disable */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';
import { initAnalytics, logPageView } from './analytics';
import { initFetchTracker } from './setupFetchTracking';
import StoreProvider from './Store/StoreProvider';
import { FileUploadProvider } from './Store/FileUploadProvider';

initAnalytics();

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

ReactDOM.render(
  <BrowserRouter>
    <AnalyticsTracker />
    <StoreProvider >
      <FileUploadProvider>
        <App />
      </FileUploadProvider>
    </StoreProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
